import HttpService from "../../constant/Api";

const API = "v1/user/profile";
export const getProfile = () => {
  return HttpService.get(API);
};

export const updateProfile = (data = {}) => {
  return HttpService.patch(API, data);
};
